Collection = new Object();
Collection.init = function() {
    $('body').on('click', ".collection-page-view .collection-filter.main-collection-filter .filter-action", function (e) {
        Collection.openFilters();
    });

    $('body').on('click', ".collection-page-view .filters-modal.main-filters-modal .filters-head .close-filters, .collection-page-view .filters-modal.main-filters-modal .filter-foot .button, .filters-modal-backdrop.main-filters-modal-backdrop", function (e) {
        Collection.closeFilters();
    });
 
    $(window).on('resize', function(){
        if ($(".filters-modal.main-filters-modal").hasClass('filters-opened')) {
            Collection.fitFiltersModalSize();
        }
        if ($(".filters-modal.boost-pfs-filter-modal").hasClass('filters-opened')) {
            Collection.fitPFSFiltersModalSize();
        }
    });

    $('body').on('click', ".collection-filter.pfs-filter-collection .filter-action", function (e) {
         Collection.openPFSFilters();
    });

   $('body').on('click', ".filters-modal.boost-pfs-filter-modal .filters-head .close-filters, .filters-modal.boost-pfs-filter-modal .filter-foot .button, .filters-modal-backdrop.boost-pfs-filters-modal-backdrop", function (e) {
        Collection.closePFSFilters();
    });
}

Collection.fitFiltersModalSize = function() {
    let height = $(window).height();
    let filtersHeadHeight = $(".filters-modal.main-filters-modal .filters-head-container").outerHeight();
    let filtersFootHeight = $(".filters-modal.main-filters-modal .filter-foot").outerHeight();
    let filtersContentHeight = height - filtersHeadHeight - filtersFootHeight;

    $(".filters-modal.main-filters-modal .filters-content").css("max-height",  filtersContentHeight  + "px");
};

Collection.openFilters = function() {
    Collection.fitFiltersModalSize();
    $('.filters-modal.main-filters-modal').addClass('filters-opened'); 
    $('.filters-modal.main-filters-modal').animate({"right":"0px"}, 300);
    $('.filters-modal-backdrop.main-filters-modal-backdrop').fadeIn(250);
    $('#reamaze-widget').hide();
}; 

Collection.closeFilters = function() {
    $('.filters-modal.main-filters-modal').animate({"right":"-100%"}, 400);
    $('.filters-modal-backdrop.main-filters-modal-backdrop').fadeOut(400, function() {
      $('#reamaze-widget').show();
      $('.filters-modal.main-filters-modal').removeClass('cart-opened');
    });
};

Collection.openPFSFilters = function() {
    Collection.fitPFSFiltersModalSize();
    $('.filters-modal.boost-pfs-filter-modal').addClass('filters-opened'); 
    $('.filters-modal.boost-pfs-filter-modal').animate({"right":"0px"}, 300);
    $('.filters-modal-backdrop.boost-pfs-filters-modal-backdrop').fadeIn(250);
    $('#reamaze-widget').hide();
}; 

Collection.fitPFSFiltersModalSize = function() {
    let height = $(window).height();
    let filtersHeadHeight = $(".filters-modal.boost-pfs-filter-modal .filters-head-container").outerHeight();
    let filtersFootHeight = $(".filters-modal.boost-pfs-filter-modal .filter-foot").outerHeight();
    let filtersContentHeight = height - filtersHeadHeight - filtersFootHeight;

    $(".filters-modal.boost-pfs-filter-modal .filters-content").css("max-height",  filtersContentHeight  + "px");
};

Collection.closePFSFilters = function() {
    $('.filters-modal.boost-pfs-filter-modal').animate({"right":"-100%"}, 400);
    $('.filters-modal-backdrop.boost-pfs-filters-modal-backdrop').fadeOut(400, function() {
      $('#reamaze-widget').show();
      $('.filters-modal.boost-pfs-filter-modal').removeClass('cart-opened');
    });
};


function appendSaleBanners(){
    var bannersExists = 0;
    $('.collection-products-grid  .Collection_inner_grid_banner').each(function(){
        bannersExists++;
    });

    if (bannersExists == 0){
        bannerHtml = $('.banner_html_content_to_append--js').html();
        var indexing = 0;
        // $('.product-item').each(function(){
        //     indexing++;
        //     if ($(window).width() < 960) {
        //         if (indexing == 5 || indexing == 11 || indexing == 17 ){
        //             // here
        //             $(this).html(bannerHtml);
        //         }
        //     }
        //     else{
        //         if (indexing == 5 || indexing == 17 ){
        //             // here
        //             $(this).html(bannerHtml);
        //         }
        //     }
                    
            
        // });

          $('.product-item').each(function(){
            indexing++;
            if ($(window).width() < 960) {
                if (indexing == 4 || indexing == 10 || indexing == 16) {
                    // Append bannerHtml after the product-item, keeping its content intact
                    $(this).after(bannerHtml);
                }
            } else {
                if (indexing == 4 || indexing == 15) {
                    // Append bannerHtml after the product-item, keeping its content intact
                    $(this).after(bannerHtml);
                }
            }
        });
              
    }
    // console.log(bannerHtml, bannersExists, 'banners');
}

$(document).ready(function(){
    Collection.init();

    setInterval(function(){
        appendSaleBanners();
    },1000);

    $(window).scroll(function() {

        // console.log($('.Sticky_announcment_bar_outer').height());
        // console.log($('#header').height());
        // console.log($('.collection-banner-section').height());

        var fromTop = ($('.Sticky_announcment_bar_outer').height() + $('#header').height() + $('.collection-banner-section').height())- 60;

        console.log(fromTop);
        if ($(window).width() < 767) {
            fromTop = fromTop - 35;
        }

        if ($(window).scrollTop() > fromTop) {
            // console.log('sticky');
            $('.filter_main_tab').addClass('sticky');
            $('.filter_spacer').show();
            $('.filter_spacer').css('height', $('.filter_main_tab').height() + 'px' );
         } else {
            //  console.log('not sticky');
             $('.filter_main_tab').removeClass('sticky');
             $('.filter_spacer').hide();
         }
        
    });
    
});